import * as storage from './storage';

const prefix = "chb3";

export function getAuth() {
    return storage.get(prefix + '.auth_token') || null;
}

export function setAuth(token) {
    storage.set(prefix + '.auth_token', token);
}

export function getDefaultUser() {
    return storage.get(prefix + '.login_mobile') || '';
}

export function setDefaultUser(user) {
    storage.set(prefix + '.login_mobile', user);
}
